import Checkbox from './ant';

export default Checkbox;
